module.exports = __webpack_public_path__ + "img/07_Screenshot 2025-06-13 at 14.02.40.ba66f840.jpg";